import {closeModal} from "../../modal/modal"
import {packetaOptions, setPacketaValues} from "../../items/packeta-parcel-item/packeta-parcel-item"
import "../../items/balikovna-parcel-item/balikovna-parcel-item"

const iframeModals = document.querySelectorAll<HTMLElement>(".m-iframe")
const iframeHiddenInputs = document.querySelectorAll<HTMLInputElement>(".f-radio-box__parcel-hidden-input input, .f-radio-box__balikovna-hidden-input input")

export const disableIframeHiddenInputs = () => {
  iframeHiddenInputs.forEach((input) => {
    const parentRadioBox = input.closest<HTMLElement>(".f-radio-box")
    if (parentRadioBox?.querySelector<HTMLInputElement>('input[type="radio"]:checked')) return
    input.disabled = true
  })
}

iframeModals.forEach((modal) => {
  const iframe = modal.querySelector<HTMLIFrameElement>("iframe")
  const url = new URL(iframe?.getAttribute("src"))
  const iframeUrl = `${url.protocol}//${url.hostname}`
  console.log(iframeUrl)
  const resultInput = document.querySelector<HTMLInputElement>(`[id="${modal.id}-result"]`)
  if (!resultInput) return

  const setResultInputValue = (value: string) => {
    disableIframeHiddenInputs()
    resultInput.disabled = false
    resultInput.value = value
  }

  const setParcelName = (value: string) => {
    const radioBoxField = document.querySelector<HTMLElement>(`.f-radio-box[data-modal-target="${modal.id}"]`)
    if (!radioBoxField) return
    const radioBoxInput = radioBoxField.querySelector<HTMLInputElement>("input")
    if (!radioBoxInput) return
    radioBoxInput.checked = true
    radioBoxInput.dispatchEvent(new Event("change"))
    const parcelName = radioBoxField.querySelector<HTMLElement>(".f-radio-box__parcel-name")
    if (!parcelName) return
    parcelName.innerText = value
  }

  const setPacketaItem = (data: object) => {
    const radioBoxField = document.querySelector<HTMLElement>(`.f-radio-box[data-modal-target="${modal.id}"]`)
    if (!radioBoxField) return
    const radioBoxInput = radioBoxField.querySelector<HTMLInputElement>("input")
    if (!radioBoxInput) return
    radioBoxInput.checked = true
    radioBoxInput.dispatchEvent(new Event("change"))
    const radioBoxPacketaItem = radioBoxField.querySelector<HTMLInputElement>(".f-radio-box__parcel-info")
    console.log(radioBoxPacketaItem)
    if (!radioBoxPacketaItem) return
    const packetaOptions: packetaOptions = {
      name: data.place as string,
      city: data.city as string,
      zip: data.zip as string,
      address: data.nameStreet as string,
      opening: data.openingHours.tableLong as string,
      description: data.directions,
      img: data.photo[0].normal,
    }
    setPacketaValues(radioBoxPacketaItem, packetaOptions)
  }

  const iframeListener = (event) => {
    console.log(event.data, !(iframeUrl === event.origin), iframeUrl)
    if (!(iframeUrl === event.origin)) return
    if (event.data.message === "pickerResult") {
      setResultInputValue(event.data.id)
      setParcelName(event.data.point.address)
    } else if (event.data.dpdWidget) {
      setResultInputValue(event.data.dpdWidget.id)
      setParcelName(event.data.dpdWidget.pickupPointResult)
    } else if (event.data.packetaSelectedId) {
      setResultInputValue(event.data.packetaSelectedId)
      setPacketaItem(event.data.packetaSelectedData)
    }
    closeModal(modal)
  }

  window.addEventListener("message", iframeListener)
})
